export function visibilityParams(): {hidden: string, visibilityChange: string} {

  if (typeof document.hidden !== "undefined") { // Opera 12.10 and Firefox 18 and later support
    return {hidden: 'hidden',visibilityChange: 'visibilitychange'};
  } else if (typeof document['msHidden'] !== "undefined") {
    return {hidden: 'msHidden',visibilityChange: 'msvisibilitychange'};
  } else if (typeof document['webkitHidden'] !== "undefined") {
    return {hidden: 'webkitHidden',visibilityChange: 'webkitvisibilitychange'};
  }
  return {hidden: 'hidden',visibilityChange: 'visibilitychange'};
}
